require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./facilitators-sending-event-invitations-c-7-e-ykcl-ctna-gy-8-a-kki-4-ew-as.json") })
        }
      }, "path---facilitators-sending-event-invitations-c-7-e-ykcl-ctna-gy-8-a-kki-4-ew-as");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---facilitators-sending-event-invitations-c-7-e-ykcl-ctna-gy-8-a-kki-4-ew-as!./.cache/json/facilitators-sending-event-invitations-c-7-e-ykcl-ctna-gy-8-a-kki-4-ew-as.json
// module id = 350
// module chunks = 231608221292675